import { render, staticRenderFns } from "./SingleDocument.vue?vue&type=template&id=b04506d6&"
import script from "./SingleDocument.ts?vue&type=script&lang=ts&"
export * from "./SingleDocument.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports